import React from 'react';
import Select from 'react-virtualized-select';
import { FormGroup } from 'common/components/form_fields';

const TaggingField = (props) => {
  const {
    input, label, value, options, clearable=true, useInputValue, resetValue,
    meta: { touched, error }
  } = props;

  return (
    <FormGroup field={{ ...props, formClasses: "tagging-field" }}>
      { !!label &&
      <label htmlFor={`field-id-${input.name}`}>
        <span className={classnames({'error-msg': !!error })}>{ label }</span>
      </label> }
      <div className="select-typable">
          <Select
            {...input}
            onBlur={() => input.onBlur? input.onBlur(value) : {}}
            options={options}
            value={useInputValue? input.value : value}
            simpleValue={true}
            clearable={clearable}
            searchable={true}
            resetValue={resetValue}
          />
        { touched && !!error && <span className="error-msg">{ error }</span> }
      </div>
    </FormGroup>
  );
};

export default TaggingField;
